<template lang="">
    <div class="bbs_filter">
      <div class="lft_area">
        <div class="bbs_info">
          <div class="total"><strong>
            {{ getCurrentCount() }}
          </strong> / {{ this.campaignListCount }}</div>
        </div>
      </div>
      <div class="rgt_area">
        <div class="bbs_srch">
          <select name="" id="" class="i_sel" v-model="searchType">
            <option
              v-for="option in searchOptions"
              :value="option.value"
            >{{ option.name }}</option>
          </select>
          <input type="text" class="i_txt" name="keyword" v-model="searchWord">
          <button type="button" class="bt_base gray btn_srch" @click="getSearch">검색</button>
        </div>
      </div>
    </div>
  
    <div class="bbs_list">
      <table class="bbs_tbl">
        <colgroup>
          <col style="width:70px">
          <col style="width:30px">
          <col style="width:90px">
          <col style="width:auto">
          <col style="width:130px">
          <col style="width:130px">
          <col style="width:130px">
        </colgroup>
        <thead>
          <tr>
            <th scope="col"><span class="ui_chkbox primary nontxt"><input type="checkbox" name="" @change="toggleAllCheck($event.target.checked)"><label for=""></label></span></th>
            <th scope="col">번호</th>
            <th scope="col">카테고리</th>
            <th scope="col">캠페인명</th>
            <th scope="col">후원기간</th>
            <th scope="col">금액</th>
            <th scope="col">등록일</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(campaign, index) in campaignList"
          >
            <td>
              <span class="ui_chkbox primary nontxt">
                <input
                  type="checkbox" 
                  :value="campaign.campaignSeq"
                  v-model="selectedCampaigns"
                >
                <label for=""></label></span>
            </td>
            <td>{{ campaign.order }}</td>
            <td><span class="medium">{{ checkEmptyCategory(campaign.category) }}</span></td>
            <td class="subject"><a @click="toCampaign(campaign.campaignSeq)">{{ campaign.campaignName }}</a></td>
            <td>
              <div class="ui_datetime">
                <span class="date">{{ checkEndDate(campaign.endDate) }}</span>
                <span class="time"></span>
              </div>
            </td>
            <td class="medium">{{ $addComma(campaign.campaignAmount) }}</td>
            <td>
              <div class="ui_datetime">
                <span class="date">{{ campaign.createDate }}</span>
                <span class="time"></span>     
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  
    <div class="paginate">
      <AdminPagination
        :totalPages = "totalPages()"
        :currentPage = "currentPage"
        @changePage = "changePage"
      />
  
      <div class="rgt_area">
        <button type="button" class="bt_base primary large_h" @click="createCampaign">등록</button>
        <button type="button" class="bt_base gray large_h" @click="deleteCampaigns">삭제</button>
      </div>
    </div>
  </template>
  <script>
  import { mapActions, mapState } from 'vuex';
  import AdminPagination from '@/components/common/AdminPagination.vue';
  
  const adminCampaignModule = 'adminCampaignModule'
  
  export default {
    components: {
      AdminPagination
    },
  
    data () {
      return {
        currentPage: 1,
        selectedCampaigns: [],
  
        searchOptions: [
          { name: '전체', value: 'all' },
        ],
        searchType: 'all',
        searchWord: ''
      }
    },
  
    methods: {
      ...mapActions(adminCampaignModule, [
        'requestCampaignList',
        'requestDeleteCampaigns'
      ]),
  
      createCampaign() {
        this.$router.push({ name: "CampaignManageCreatePage" })
      },
  
      toCampaign(campaignSeq) {
        this.$router.push({
          name: "CampaignManageCreatePage",
          query: { campaignSeq: campaignSeq },
        });
      },
  
      totalPages() {
        return Math.ceil(this.campaignListCount / 10);
      },
  
      async changePage(page) {
        this.currentPage = page
        const {currentPage, searchType, searchWord} = this
        await this.requestCampaignList({currentPage, searchType, searchWord})
      },
  
      getCurrentCount() {
        const currentFirstCount = (this.currentPage - 1) * 10 + 1
        let currentLastCount = this.currentPage * 10
        if (parseInt(currentLastCount) > parseInt(this.campaignListCount)) {
          currentLastCount = this.campaignListCount
        }
        return currentFirstCount + '-' + currentLastCount
      },
  
      toggleAllCheck(isChecked) {
        if (isChecked) {
          this.selectedCampaigns = []
          for (const campaign of this.campaignList) {
            this.selectedCampaigns.push(campaign.campaignSeq)
          }
        } else {
          this.selectedCampaigns = []
        }
      },
  
      async deleteCampaigns() {
        if (this.selectedCampaigns.length === 0) {
          alert('선택된 캠페인이 없습니다');
          return;
        }
  
        const { searchType, searchWord, currentPage } = this;
        const fetchCampaigns = async (page = 1, type = searchType, word = searchWord, isReset = false) => {
          const params = { currentPage: page, searchType: type, searchWord: word };
          await this.requestCampaignList(params);
          if (isReset) {
            this.searchType = 'all';
          }
        };
  
        await this.requestDeleteCampaigns(this.selectedCampaigns);
        this.selectedCampaigns = [];
  
        await fetchCampaigns(currentPage);
  
        if (this.campaignList.length === 0 && this.currentPage > 1) {
          this.currentPage -= 1;
          await fetchCampaigns(this.currentPage);
        }
  
        if (this.campaignList.length === 0 || this.currentPage === 1) {
          this.currentPage = 1;
          this.searchType = '';
          this.searchWord = '';
          await fetchCampaigns(1, '', '', true);
        }
      },
  
      checkEmptyCategory(name) {
        if (name === "") {
          return "카테고리 없음"
        } else return name
      },

      checkEndDate(endDate) {
        if (endDate) {
          return "~ " + endDate;
        }
        return "상시후원"
      },
  
      async getSearch() {
        if (this.searchWord === '') {
          alert('검색어를 입력해주세요')
          return
        }
        this.currentPage = 1
        const {currentPage, searchType, searchWord} = this
        await this.requestCampaignList({currentPage, searchType, searchWord})
      }
    },
  
    computed: {
      ...mapState(adminCampaignModule, [
        'campaignList',
        'campaignListCount'
      ])
    },
  
    async mounted() {
      const {currentPage, searchType, searchWord} = this
      await this.requestCampaignList({currentPage, searchType, searchWord})
    }
  }
  </script>
  <style lang="">
      
  </style>